// @flow @format

import { type RouterHistory } from 'react-router-dom';
import { combineReducers, type CombinedReducer } from 'redux';
import { connectRouter } from 'connected-react-router';

import type { Action, CustomSelector, Selector, StoreState } from './types';
import { default as entities } from './reducer/entities';
import { injectStateSelector } from './utils';
import activity from './reducer/activity';
import auth from './reducer/auth';
import config from './reducer/config';
import meta from './reducer/meta';
import profile from './reducer/profile';
import progresses from './reducer/progresses';
import ranking from './reducer/ranking';
import term from './reducer/term';

const reducersMap = {
  profile,
  config,
  progresses,
  auth,
  term,
  entities,
  meta,
  ranking,
  activity,
};

type ExtractStore = <T>(T) => $Call<T, *, *>;

const createRootReducer = (
  history: RouterHistory
): CombinedReducer<$ObjMap<typeof reducersMap, ExtractStore>, Action> =>
  // $FlowIgnore
  combineReducers({
    router: connectRouter(history),
    ...reducersMap,
  });
export default createRootReducer;

// Selectors

const getAuth = (state: StoreState) => state.auth;
export const getEntities = (state: StoreState) => state.entities;
export const getProgresses = (state: StoreState) => state.progresses;
const getRanking = (state: StoreState) => state.ranking;

export function injectAuth<T>(selector: CustomSelector<*, T>): Selector<T> {
  return injectStateSelector(getAuth)(selector);
}

export function injectEntities<T>(selector: CustomSelector<*, T>): Selector<T> {
  return injectStateSelector(getEntities)(selector);
}

export function injectProgresses<T>(selector: CustomSelector<*, T>): Selector<T> {
  return injectStateSelector(getProgresses)(selector);
}

export function injectRanking<T>(selector: CustomSelector<*, T>): Selector<T> {
  return injectStateSelector(getRanking)(selector);
}
